import { render, staticRenderFns } from "./trainingModulePageNew11.vue?vue&type=template&id=e544e324&scoped=true&"
import script from "./trainingModulePageNew11.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew11.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew11.vue?vue&type=style&index=0&id=e544e324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e544e324",
  null
  
)

export default component.exports